<template>
  <div class="generateCert">
    <div class="title">
      <h1>生成证书</h1>
    </div>

    <div
      class="contentBox"
      v-loading="loading"
      element-loading-text="生成证书中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.7)"
    >
      <div class="info">
        <el-form :model="CertForm" :rules="rules" ref="CertForm">
          <el-form-item label-width="220px" label="您的姓名" prop="name">
            <el-input
              v-model="CertForm.name"
              placeholder="请输入姓名"
              clearable
            ></el-input>
            <p>您的姓名将会显示在证书上</p>
          </el-form-item>

          <el-form-item label-width="220px" label="手机号/账号" prop="tel">
            <el-input
              v-model="CertForm.tel"
              placeholder="请输入您的常用手机号或您已有的ICode账号"
              clearable
            ></el-input>
            <p>使用该手机号或账号登录ICode平台，可永久保存并下载此证书</p>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn">
        <span @click="submitForm('CertForm')">生成证书</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // let checkPhone = (rule, value, callback) => {
    //   let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;

    //   if (!reg.test(value)) {
    //     callback(new Error("请输入11位手机号"));
    //   } else {
    //     callback();
    //   }
    // };

    let checkPorA = (rule, value, callback) => {
      // let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      let reg1 = /^[a-zA-z][a-zA-Z0-9]*$/;
      let reg2 = /^\d+$/;


      if (!reg1.test(value) && !reg2.test(value)) {
        callback(new Error("请输入正确的手机号或账号"));
      } else {
        callback();
      }
    };

    return {
      loading: false,

      CertForm: {
        name: "",
        tel: "",
      },

      rules: {
        name: [
          {
            required: true,
            message: "生成证书需要您的姓名",
            trigger: "blur",
          },
          {
            min: 2,
            message: "请输入正确的姓名",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "生成证书需要您的手机号或账号",
            trigger: "blur",
          },
          {
            min: 2,
            // max: 11,
            validator: checkPorA,
            message: "请输入正确的手机号码或账号",
            trigger: "blur",
          },
        ],
      },

      gameIdTemp: 0,
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;

          try {
            this.$http
              .getAxios("award/award", {
                method: "post",
                data: {
                  name: this.CertForm.name,
                  phone: this.CertForm.tel,
                  gameId: this.gameIdTemp,
                },
              })
              .then((res) => {
                var res = res.data;

                if (res.code == "0") {
                  sessionStorage.setItem("certName", this.CertForm.name);
                  sessionStorage.setItem("certPhone", this.CertForm.tel);

                  // 获取证书编号和证书生成时间
                  this.passValidForm();
                } else if (res.code == "126") {
                  this.loading = false;
                  this.$notify.error({
                    title: "错误",
                    message:
                      "该手机号已拥有编程一小时证书，请注册后在我的比赛中查看",
                    duration: 0,
                  });
                } else if (res.code == "127") {
                  this.loading = false;
                  this.$notify.error({
                    title: "错误",
                    message: "手机号格式错误",
                  });
                } else {
                  this.loading = false;
                  this.$notify.error({
                    title: "错误",
                    message:
                      "错误代码：ohc-a-d-" + res.code + "请联系ICode管理员",
                  });
                }
              });
          } catch (error) {
            console.error("错误", error);
          }
        } else {
          return false;
        }
      });
    },

    passValidForm() {
      try {
        this.$http
          .getAxios("award/getAward", {
            method: "get",
            params: {
              type: "tourist",
            },
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == "0") {
              sessionStorage.setItem("certId", _res.data.number);
              sessionStorage.setItem(
                "certTime",
                this.format(_res.data.createTimestamp * 1000)
              );

              this.loading = false;
              this.$router.push({ path: "/oneHourGetCert" });
            } else {
              this.loading = false;
              this.$notify.error({
                title: "错误",
                message: "错误代码：ct-0343，请联系ICode管理员",
              });
            }
          });
      } catch (error) {
        console.log("错误代码：ct-0344", error);
      }
    },

    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format(t) {
      //t是整数，否则要parseInt转换
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      // var hours = time.getHours();
      // var minutes = time.getMinutes();
      // var seconds = time.getSeconds();

      return (
        y + "-" + this.add0(m) + "-" + this.add0(d)
        // " " +
        // this.add0(hours) +
        // ":" +
        // this.add0(minutes) +
        // ":" +
        // this.add0(seconds)
      );
    },
  },

  mounted() {
    let g = window.location.href.split("?")[1]
      ? window.location.href.split("?")[1]
      : null;

    if (g === null) {
      this.$notify.error({
        title: "错误",
        message: "请正常参加比赛后领取证书，将在5秒后返回活动首页",
        duration: 5000,
      });

      setTimeout(() => {
        this.$router.push({ path: "/oneHourCoding" });
      }, 5000);
    } else if (g.split("=")[0] === "game") {
      if (g.split("=")[1] == "123001" || g.split("=")[1] == "123002") {
        this.gameIdTemp = parseInt(g.split("=")[1]);
      } else {
        this.$notify.error({
          title: "错误",
          message: "请正常参加比赛后领取证书",
          duration: 5000,
        });
        setTimeout(() => {
          this.$router.push({ path: "/oneHourCoding" });
        }, 5000);
      }
    } else {
      this.$notify.error({
        title: "错误",
        message: "请正常参加比赛后领取证书",
        duration: 5000,
      });
      setTimeout(() => {
        this.$router.push({ path: "/oneHourCoding" });
      }, 5000);
    }
  },
};
</script>

<style lang="scss">
.generateCert {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .title {
    width: 40vw;
    height: 10vh;
    margin-bottom: 5vh;

    h1 {
      width: 100%;
      color: #0ff;
      font-size: 2vw;
      line-height: 3vw;
      background: url("~@/assets/images/event/oneHourCode/cert-title.png")
        center / contain no-repeat;
    }
  }

  .contentBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1108px;
    height: 594px;
    background: url("~@/assets/images/event/oneHourCode/cert-bg2.png") center /
      contain no-repeat;

    .info {
      width: 75%;
      margin-top: -100px;

      .el-form {
        p {
          font-size: 16px;
          color: #0ff;
          text-align: left;
        }

        &-item__label {
          text-align: left;
          color: #0ff;
          font-size: 34px;
        }

        .el-input__inner {
          color: #fff;
          font-size: 16px;
          border-radius: 0;
          border: 1px solid rgba(0, 255, 255, 0.6);
          background: #1e5a85;
        }

        input::-webkit-input-placeholder {
          color: #0ff;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #0ff;
        }
        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #0ff;
        }
        input:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #0ff;
        }
      }
    }

    .btn {
      width: 15vw;
      height: 50px;
      line-height: 50px;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        display: block;
        width: 240px;
        color: #fff;
        font-size: 26px;
        background: url("~@/assets/images/event/oneHourCode/cert-btn.png")
          center / contain no-repeat;
        cursor: pointer;
        transition: 0.4s ease all;

        &:hover {
          transform: scale(1.05);
        }
      }

      .el-loading {
        &-spinner {
          margin-top: -33px;
        }

        &-text {
          line-height: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ohcGenerateCert.vue